import * as Sentry from '@sentry/react'
import { TOptions } from 'i18next'

import { TranslationKeys } from '@/@types/keys/translation'
import { toastContainerSchema } from '@/@types/schemas/toast-containers'
import { showError, showWarning } from '@/components/toast'
import { HttpError } from '@/services/fintalk/api/types/errors/HttpError'
import { NetworkError } from '@/services/fintalk/api/types/errors/NetworkError'

type GetTranslation = (key: TranslationKeys, params?: TOptions) => string

export function handleAuthError(
  error: unknown,
  getTranslation: GetTranslation,
  consumer?: string,
): void {
  if (error instanceof NetworkError) {
    showError({
      title: getTranslation('common.messages.errors.networkError.title'),
      description: getTranslation(
        'common.messages.errors.networkError.description',
      ),
      containerId: toastContainerSchema.Enum.GLOBAL,
    })

    return
  }

  if (error instanceof HttpError) {
    const statusCode = error.response?.statusCode

    if (statusCode === 404) {
      showWarning({
        title: getTranslation('common.validations.userNotFound'),
        description: '',
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return
    }

    if (statusCode === 401) {
      showWarning({
        title: getTranslation('common.validations.invalidData'),
        description: '',
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return
    }

    if (statusCode === 429) {
      showWarning({
        title: getTranslation('common.toast.warning.tooManyRequests.title'),
        description: getTranslation(
          'common.toast.warning.tooManyRequests.description',
        ),
        containerId: toastContainerSchema.Enum.GLOBAL,
      })

      return
    }
  }

  Sentry.captureException(error, {
    extra: {
      consumer,
    },
  })

  showError({
    title: getTranslation('common.messages.errors.unknownError.title'),
    description: getTranslation(
      'common.messages.errors.unknownError.description',
    ),
    containerId: toastContainerSchema.Enum.GLOBAL,
  })
}
